import { render, staticRenderFns } from "./InteractiveImage.vue?vue&type=template&id=fdfb096e&scoped=true"
import script from "./InteractiveImage.vue?vue&type=script&lang=js"
export * from "./InteractiveImage.vue?vue&type=script&lang=js"
import style0 from "./InteractiveImage.vue?vue&type=style&index=0&id=fdfb096e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfb096e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdfb096e')) {
      api.createRecord('fdfb096e', component.options)
    } else {
      api.reload('fdfb096e', component.options)
    }
    module.hot.accept("./InteractiveImage.vue?vue&type=template&id=fdfb096e&scoped=true", function () {
      api.rerender('fdfb096e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InteractiveImage.vue"
export default component.exports